import React from "react";
import { Box, Grid, IconButton, Tooltip, Menu, MenuItem } from "@mui/material";
import Typography from "../../../../Typography";
import PropTypes from "prop-types";
import { Reddit } from '@mui/icons-material';
import { CircularProgress } from "@mui/material";
import { emojiReplaceJSX } from "../../../../../utils/emojiDict";
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import SubjectIcon from '@mui/icons-material/Subject';
import EmailIcon from '@mui/icons-material/Email';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DraggableBox from "../../../../../utils/draggableBox";
import ReactHtmlParser from 'react-html-parser';
import { htmlEntities } from '../../../../../utils/emojiDict';
import PhoneIcon from "@mui/icons-material/Phone"

import "./styles.css";
import AttachmentItem from "./attachment";
import { calcDate } from "../NewMessageArea";

import DocumentIcon from "@mui/icons-material/InsertDriveFile"
import ChatImage from "../../../../ChatImage"
import AudioPlayer from "../../../../AudioPlayer"
import { setPendingQuickAsk } from "../../../../CortexAssistant/pendingQuickAsk"

import ReactAudioPlayer from "react-audio-player"

import { getSession } from "../../../../../auth"
import { resolveMediaFileName, stripHashSuffix } from "../../../../../utils/mediaFileName"

const urlRegex = /(http|ftp|https):\/\/([\w_-]+(?:\.[\w_-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])|www\.([\w_-]+(?:\.[\w_-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])/g

const CTAregex = /\[link\](?<link>.*?)\[\/link\]\[button\](?<button>.*?)\[\/button\]\[message\](?<message>.*?)\[\/message\]/s;

const htmlRegex = /<\/?[a-z][\s\S]*>/i;

const decodeHtmlEntities = (text) => {
    if (!text) return '';
    let t = text.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    t = t.replace(/&amp;lt;/g, '<').replace(/&amp;gt;/g, '>');
    return t;
};

export const getAttachments = (regex, value) => {
    const reference = value
    let data = []
    if (!reference)
        return { response: '', data: [] }
    const response = reference.replace(regex, (a, b) => { data.push(JSON.parse(b)); return '' })
    return { response: response, data: data }
}

const specialReplace = (regex, value) => {

    const reference = value
    //matched -> the string that matched regex
    //the internals of the matched string ->
    //index: -> the index of the string that matched
    // replaced: the string without the matched string.

    let data = { matched: '', internal: '', index: '', replaced: '' }
    const replaced = reference.replace(regex, (a, b, c, d) => { data = { matched: a, internal: b, index: c }; return '' })
    data.replaced = replaced
    return data
}


class MessageItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            messageMenuAnchorEl: null,
            audioError: false,
            showHtmlModal: false,
            htmlContent: '',
            documentFileUrl: null,
            documentFileName: null
        }

        this.lineBreak_1 = '<br>';
        this.lineBreak_2 = '\n';
    }

    componentDidMount() {
        this.resolveDocumentFileNameIfNeeded()
    }

    componentDidUpdate() {
        this.resolveDocumentFileNameIfNeeded()
    }

    getDocumentUrl = () => {
        if (this.isDocumentMessage())
            return this.props.message.message.replace("[url=", "").replace("]Baixar arquivo[/url]", "")

        if (this.isDocumentMessage2()) {
            const parts = this.props.message.message.replace("wpp-document:", "")
            const [mediaId, date] = parts.split(";")
            return `api/api/whatsapp/document/${getSession().profile.enterprise.accountcode}/${date}/${mediaId}/`
        }

        return null
    }

    resolveDocumentFileNameIfNeeded = () => {
        const documentUrl = this.getDocumentUrl()

        if (!documentUrl || documentUrl === this.state.documentFileUrl)
            return

        this.setState({ documentFileUrl: documentUrl, documentFileName: null })

        resolveMediaFileName(documentUrl).then((resolvedName) => {
            if (resolvedName && this.getDocumentUrl() === documentUrl)
                this.setState({ documentFileName: stripHashSuffix(resolvedName) })
        })
    }

    isThereSurvey = (message) => {
        const isThereSurvey =
            message.includes("msgini=") &&
            message.includes("msgend=") &&
            message.includes("text=") &&
            message.includes("id=");

        return isThereSurvey;
    }

    areThereButtons = (message) => {
        const areThereButtons =
            message.includes("title=") &&
            message.includes("][button") &&
            message.includes("action=");

        return areThereButtons;
    }

    

    parseMessage = (message) => {
        const escape = htmlEntities;

        if (this.props.type === 'CTA') {

            const match = message.match(CTAregex);

            if (match?.groups) {
            
                const resultado = {
                    link: match.groups.link,
                    button: match.groups.button,
                    message: match.groups.message.trim()
                };

                if (resultado.link) {
                    return `${escape(resultado.message)}<br>[[CTA|${escape(resultado.button)}|${resultado.link}]]`;
                }

                return escape(`${resultado.message}\n${resultado.button}`);
            }

            return escape("Mensagem interativa de CTA.")
        }
        else if (this.props.type === 'buttons' && this.areThereButtons(message)) {
            const title = message.split('title=')[1].split('][button')[0];
            const actions = this.getActions(message);

            return escape(`${title}${this.lineBreak_1}${actions.join(', ')}`);

        }
        else if (this.props.type === 'survey' && this.isThereSurvey(message)) {
            // const msgIni = message.split('msgini=')[1].split('msgend=')[0];
            // const text = message.split('text=')[1].split('id=')[0];

            return escape('Início da pesquisa de satisfação.') // `${msgIni}${this.lineBreak_1}${text}`;
        }

        // remove any remaining html tags (<tag> or </tag>) before escaping
        const stripped = message.replace(/<[A-Za-z\/][^>]*>/g, '');
        return escape(stripped);
    }

    getActions = (message) => {
        const parts = message.split('action=').slice(1);

        const actions = [];
        parts.forEach((part) => {
            actions.push(part.substring(0, part.indexOf(']')));
        });

        return actions;
    }

    isSpecialMessage = () => {
        return ['buttons', 'survey', 'emailinbox', 'emailsent', 'CTA'].includes(this.props.type) || this.props.message?.is_survey;
    }

    sendMessageToAssistant = (message) => {
        if ('openAssistant' in window) window.openAssistant()

        // The sidebar Cortex component mounts asynchronously once opened,
        // so hand it the question through a small mailbox instead of a
        // direct call - it picks this up (and locks/asks) once ready.
        setPendingQuickAsk(this.props.activeChat?.uniqueid, message)
    }

    getMessageText = (message) => {
        if (!message)
            return ''

        if ('message' in message && message.message !== null && message.message !== undefined)
            return message.message

        if ('msg' in message && message.msg !== null && message.msg !== undefined)
            return message.msg

        return ''
    }

    isClientMessage = (message) => {
        return message && message.user_id == 0
    }

    getConsecutiveClientMessages = () => {
        const messages = Array.isArray(this.props.messages) ? this.props.messages : []
        const currentIndex = Number.isInteger(this.props.messageIndex) ? this.props.messageIndex : -1

        if (!messages.length || currentIndex < 0 || currentIndex >= messages.length)
            return [this.getMessageText(this.props.message)].filter(message => message)

        if (!this.isClientMessage(messages[currentIndex]))
            return [this.getMessageText(this.props.message)].filter(message => message)

        let start = currentIndex
        let end = currentIndex

        while (start > 0 && this.isClientMessage(messages[start - 1]))
            start -= 1

        while (end < messages.length - 1 && this.isClientMessage(messages[end + 1]))
            end += 1

        return messages
            .slice(start, end + 1)
            .map(message => this.getMessageText(message))
            .filter(message => message)
    }

    sendConsecutiveClientMessagesToAssistant = () => {
        const messages = this.getConsecutiveClientMessages()
        this.sendMessageToAssistant(messages.join('\n'))
    }

    clearInbox = (inbox) => {
        const data = inbox?.match(/<([^>]+)>/g)?.map(match => match.replace(/<|>/g, ''))
        if (data)
            return data
        return inbox
    }

    isAudioMessage = () => {
        const message = this.props.message.message
        return message.startsWith("wpp-audio:")
    }

    isDocumentMessage = () => {
        const message = this.props.message.message
        return message.startsWith("[url=") && message.endsWith("]Baixar arquivo[/url]")
    }

    isDocumentMessage2 = () => {
        const message = this.props.message.message
        return message.startsWith("wpp-document:")
    }

    isImageMessage = () => {
        const message = this.props.message.message
        return message.startsWith("[img]") && message.endsWith("[/img]")
    }

    isImageMessage2 = () => {
        const message = this.props.message.message
        return message.startsWith("wpp-image:")
    }

    isVideoMessage = () => {
        const message = this.props.message.message
        return message.startsWith("[video]") && message.endsWith("[/video]")
    }

    isVideoMessage2 = () => {
        const message = this.props.message.message
        return message.startsWith("wpp-video:")
    }

    obfuscateMessage = (text) => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
        return text
            .split("")
            .map((ch) => (ch === " " 
                ? " "
                : chars.charAt(Math.floor(Math.random() * chars.length))
            ))
            .join("")
    }

    displayMessage = (shouldBlurMessage=false) => {
        let props_message = this.props.message.message;

        if (this.props.message.status === 'DELETED' && !this.props.media)
            props_message = 'Essa mensagem foi removida pelo usuário.'

        if (this.props.receiveURL === false)
            props_message = props_message.replaceAll(urlRegex, ' - URL Bloqueada -')

        if (this.props.user === -9)
            props_message = "Chamada de voz"

        if (this.isAudioMessage()) {
            const parts = this.props.message.message.replace("wpp-audio:", "")
            const [mediaId, date] = parts.split(";")
            return (
                <Box sx={{ width: "300px" }}>
                    <ReactAudioPlayer
                        style={{ width: "250px", margin: "5px 0", height: "40px" }}
                        onError={() => {}}
                        src={`api/api/whatsapp/audio/${getSession().profile.enterprise.accountcode}/${date}/${mediaId}/`}
                        controls
                        preload
                    />
                </Box>
            )
        }

        if (this.isDocumentMessage()) {
            const mediaUrl = this.getDocumentUrl()
            const mediaName = this.state.documentFileName || mediaUrl.split("/").pop().split("-").pop()
            return (
                <Box className="messageItem-box-2" style={{ display: "flex", gap: ".25rem" }}>
                    <DocumentIcon style={{ color: "#21446C" }}/>
                    <a target="_blank" href={mediaUrl} style={{ color: "white", textDecoration: "none" }}>{mediaName}</a>
                </Box>
            )
        }

        if (this.isDocumentMessage2()) {
            const mediaUrl = this.getDocumentUrl()
            const mediaName = this.state.documentFileName || "documento"
            return (
                <Box className="messageItem-box-2" style={{ display: "flex", gap: ".25rem" }}>
                    <DocumentIcon style={{ color: "#21446C" }}/>
                    <a target="_blank" href={mediaUrl} style={{ color: "white", textDecoration: "none", whiteSpace: "nowrap" }}>{mediaName}</a>
                </Box>
            )
        }

        if (this.isImageMessage()) {
            const mediaUrl = this.props.message.message.replace("[img]", "").replace("[/img]", "")
            return (
                <Box sx={{ maxWidth: "250px" }}>
                    <img 
                        src={mediaUrl}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                        alt="media"
                    />
                </Box>
            )
        }

        if (this.isImageMessage2()) {
            const parts = this.props.message.message.replace("wpp-image:", "")
            const [mediaId, date] = parts.split(";")
            return (
                <Box sx={{ maxWidth: "250px" }}>
                    <img 
                        src={`api/api/whatsapp/image/${getSession().profile.enterprise.accountcode}/${date}/${mediaId}/`}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                        alt="media"
                    />
                </Box>
            )
        }

        if (this.isVideoMessage()) {
            const mediaUrl = this.props.message.message.replace("[video]", "").replace("[/video]", "")
            return (
                <Box sx={{ maxWidth: "250px" }}>
                    <video 
                        src={mediaUrl}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                        alt="media"
                    />
                </Box>
            )
        }

        if (this.isVideoMessage2()) {
            const parts = this.props.message.message.replace("wpp-video:", "")
            const [mediaId, date] = parts.split(";")
            return (
                <Box sx={{ maxWidth: "250px" }}>
                    <video 
                        src={`api/api/whatsapp/video/${getSession().profile.enterprise.accountcode}/${date}/${mediaId}/`}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                        alt="media"
                        controls
                    />
                </Box>
            )
        }

        if (shouldBlurMessage)
            props_message = this.obfuscateMessage(props_message)

        if (this.isSpecialMessage()) {
            if (this.props.message?.is_survey && props_message === 'Invalid survey')
                props_message = 'Responsta inválida.'
            if (this.props.type === 'survey')
                props_message = props_message.replaceAll('[survey]', '').replaceAll('[/survey]', '')
            if (this.props.type === 'emailinbox') {
                const inbox = specialReplace(/\(emailinbox\)([\s\S]*?)\(\/emailinbox\)/g, props_message)
                const subject = specialReplace(/\(emailsubject\)([\s\S]*?)\(\/emailsubject\)/g, inbox.replaced)
                const ccResult = specialReplace(/\(emailcc\)([\s\S]*?)\(\/emailcc\)/g, subject.replaced)
                const unclear_body = ccResult.replaced
                const attachments_obj = getAttachments(/\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g, unclear_body)
                const body = attachments_obj.response.replace(/\## - (.*?) - ##/, '')
                const attachments = attachments_obj.data
                const isHtml = htmlRegex.test(decodeHtmlEntities(decodeHtmlEntities(body)))

                let recipient = inbox.internal || ''
                let cc = ''
                let cco = ''
                
                if (recipient.includes(' | CC: ')) {
                    const parts = recipient.split(' | CC: ')
                    recipient = parts[0]
                    const ccPart = parts[1]
                    if (ccPart.includes(' | CCO: ')) {
                        const ccoParts = ccPart.split(' | CCO: ')
                        cc = ccoParts[0]
                        cco = ccoParts[1]
                    } else {
                        cc = ccPart
                    }
                } else if (recipient.includes(' | CCO: ')) {
                    const parts = recipient.split(' | CCO: ')
                    recipient = parts[0]
                    cco = parts[1]
                }

                return (
                    <Box className={(shouldBlurMessage) ? "messageItem-box-2 message-blur" : "messageItem-box-2"} sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {inbox?.matched && <Box sx={{ display: 'flex', gap: '.5rem' }}>
                            <Tooltip title='Destinatário'><EmailIcon sx={{ color: 'white' }} /></Tooltip>
                            <Typography text={this.clearInbox(recipient)}
                                color="white"
                                align="start"
                                fontWeight='bold'
                                justifyContent="left"
                            />
                        </Box>}
                        {cc && <Box sx={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
                            <Tooltip title='CC'><AlternateEmailIcon sx={{ color: 'white', fontSize: '1.2rem' }} /></Tooltip>
                            <Typography text={cc}
                                color="white"
                                align="start"
                                justifyContent="left"
                                variant="body2"
                            />
                        </Box>}
                        {cco && <Box sx={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
                            <Tooltip title='CCO'><VisibilityOffIcon sx={{ color: 'white', fontSize: '1.2rem' }} /></Tooltip>
                            <Typography text={cco}
                                color="white"
                                align="start"
                                justifyContent="left"
                                variant="body2"
                            />
                        </Box>}
                        {ccResult?.matched && <Box sx={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>
                            <Tooltip title='Em cópia'><AlternateEmailIcon sx={{ color: 'white', fontSize: '1.2rem' }} /></Tooltip>
                            <Typography text={this.clearInbox(ccResult.internal)}
                                color="white"
                                align="start"
                                justifyContent="left"
                                variant="body2"
                            />
                        </Box>}
                        {subject?.matched && <Box sx={{ display: 'flex', gap: '.5rem' }}>
                            <Tooltip title='Assunto'><SubjectIcon sx={{ color: 'white' }} /></Tooltip>
                            <Typography text={subject?.internal}
                                color="white"
                                align="start"
                                fontWeight='bold'
                                justifyContent="left"
                            /></Box>}
                        <Box sx={{ display: 'flex', gap: '.5rem' }}>
                            <Box sx={{ paddingLeft: '1.5rem' }}></Box>
                            {isHtml ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                                    <Typography text="Conteúdo HTML"
                                        color="white"
                                        align="start"
                                        justifyContent="left"
                                    />
                                    <Tooltip title='Visualizar HTML'>
                                        <IconButton 
                                            size="small" 
                                            sx={{ color: 'white', padding: '2px' }}
                                            onClick={() => this.setState({ showHtmlModal: true, htmlContent: decodeHtmlEntities(body) })}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            ) : (
                                this.parseMessage(body).split(this.lineBreak_1).map(message => (
                                    <Typography text={emojiReplaceJSX(message)}
                                        color="white"
                                        align="start"
                                        justifyContent="left"
                                    />
                                ))
                            )}
                        </Box>
                        {attachments.length > 0 && <Box className='message-email-attachments'>
                            {attachments.map(attachment => <AttachmentItem data={attachment} />)}
                        </Box>}
                    </Box>
                )
            }
            if (this.props.type === 'emailsent') {
                const attachments_obj = getAttachments(/\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g, props_message)
                const body = attachments_obj.response.replace(/\## - (.*?) - ##/, '')
                const attachments = attachments_obj.data
                const isHtml = htmlRegex.test(decodeHtmlEntities(decodeHtmlEntities(body)))

                return (
                    <Box className={(shouldBlurMessage) ? "messageItem-box-2 message-blur" : "messageItem-box-2"} sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {this.props.emailTo && <Box sx={{ display: 'flex', gap: '.5rem' }}>
                            <Tooltip title='Destinatário'><EmailIcon sx={{ color: 'white' }} /></Tooltip>
                            <Typography text={this.props.emailTo}
                                color="white"
                                align="start"
                                fontWeight='bold'
                                justifyContent="left"
                            />
                        </Box>}
                        {this.props.emailSubject && <Box sx={{ display: 'flex', gap: '.5rem' }}>
                            <Tooltip title='Assunto'><SubjectIcon sx={{ color: 'white' }} /></Tooltip>
                            <Typography text={this.props.emailSubject}
                                color="white"
                                align="start"
                                fontWeight='bold'
                                justifyContent="left"
                            /></Box>}
                        <Box sx={{ display: 'flex', gap: '.5rem', flexDirection: 'column' }}>
                            {isHtml ? (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
                                    <Typography text="Conteúdo HTML"
                                        color="white"
                                        align="start"
                                        justifyContent="left"
                                    />
                                    <Tooltip title='Visualizar HTML'>
                                        <IconButton 
                                            size="small" 
                                            sx={{ color: 'white', padding: '2px' }}
                                            onClick={() => this.props.onShowHtml && this.props.onShowHtml(decodeHtmlEntities(body))}
                                        >
                                            <VisibilityIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            ) : (
                                this.parseMessage(body).split(this.lineBreak_1).map((message, idx) => (
                                    <Typography key={idx} text={emojiReplaceJSX(message)}
                                        color="white"
                                        align="start"
                                        justifyContent="left"
                                    />
                                ))
                            )}
                        </Box>
                        {attachments.length > 0 && <Box className='message-email-attachments'>
                            {attachments.map(attachment => <AttachmentItem data={attachment} />)}
                        </Box>}
                    </Box>
                )
            }

            return (
                <Box className={(shouldBlurMessage) ? "messageItem-box-2 message-blur" : "messageItem-box-2"}>
                    {this.parseMessage(props_message).split(this.lineBreak_1).map(message => (
                        <Typography text={emojiReplaceJSX(message)}
                            color="white"
                            align="start"
                            justifyContent="left"
                        />
                    )
                    )}
                </Box>
            );
        } else if (!props_message.includes(this.lineBreak_2)) {
            return (
                <Box className={(shouldBlurMessage) ? "messageItem-box-2 message-blur" : "messageItem-box-2"}>
                    {this.props.message.msg == 'SENDINGMEDIAMESSAGE' ?
                        <>
                            {this.props.message.expired ?
                                <Typography text={'Envio falhou.'}
                                    color="white"
                                    align="start"
                                    justifyContent="left"
                                />
                                :
                                <CircularProgress sx={{ color: 'white', width: '18px', padding: '.5rem' }} />
                            }
                        </>
                        :
                        <Typography text={emojiReplaceJSX(props_message)}
                            color="white"
                            align="start"
                            justifyContent="left"
                        />
                    }

                </Box>
            );
        } else if (props_message.includes(this.lineBreak_2)) {
            return (
                <Box className={(shouldBlurMessage) ? "messageItem-box-2 message-blur" : "messageItem-box-2"}>
                    {props_message.split(this.lineBreak_2).map(message => (
                        message !== "" ?
                            (<Typography text={emojiReplaceJSX(message)}
                                color="white"
                                align="start"
                                justifyContent="left"
                            />) :
                            (<br />)
                    ))}
                </Box>
            );
        }
    }

    handleMessageMenuClick = (event) => {
        this.setState({ messageMenuAnchorEl: event.currentTarget })
    }

    handleMessageMenuClose = () => {
        this.setState({ messageMenuAnchorEl: null })
    }

    replyMessage = (message) => {
        this.props.setReplying(message)
    }

    declareColor = () => {
        const chatid = this.props.activeChat?.lh_chat_id || this.props.activeChat?.id
        return `${this.props.user === -1 ? 'bgMessage bgMessage-chatbot' : 'bgMessage'} 
        ${this.props.message?.chat && (chatid !== this.props.message.chat) ? 'different-chat': ''}`
    }

    render() {
        const messageText = this.getMessageText(this.props.message)
        const presenceNotices = {
            'O usuário saiu do chat.': 'O usuário saiu do chat.',
            'O usuário retornou ao chat.': 'O usuário retornou ao chat.',
            'Cliente saiu do chat': 'O usuário saiu do chat.',
            'Cliente voltou ao chat': 'O usuário retornou ao chat.'
        }
        if (Number(this.props.user) === -1 && Object.prototype.hasOwnProperty.call(presenceNotices, messageText)) {
            return (
                <Box id={`msg-${this.props.message.id}`} className="messageItem-box-1" justifyContent="center">
                    <Box className="date-displayer" sx={{ textAlign: 'center' }}>
                        {presenceNotices[messageText]}
                    </Box>
                </Box>
            )
        }

        let replyFrom = null
        if (this.props.message.reply_from) {
            replyFrom = JSON.parse(JSON.stringify(this.props.message))
            replyFrom.message = this.props.message.reply_from
            replyFrom.reply_from = null
        }

        let containerClassName = "messageItem-box-1"
        if (this.props.replyFrom)
            containerClassName = `${containerClassName} reply-from`
        if (this.props.message.reaction)
            containerClassName = `${containerClassName} box-with-reaction`

        return (
            <Box id={`msg-${this.props.message.id}`} className={containerClassName} justifyContent={this.props.replyFrom ? 'flex-start' : this.props.user !== 0 ? 'flex-end' : 'flex-start'}>
                <Box 
                    bgcolor={this.props.message.expired ? '#909eac' : this.props.user !== 0 ? '#5399DB' : '#21446c'}
                    className={this.declareColor()}
                    id={this.props.replyFrom ? 'left-user' : this.props.user !== 0 ? 'right-user' : 'left-user'}
                >
                    <Tooltip placement='left' title={! this.props.replyFrom && this.props.message?.agent_name ? `Enviado por: ${this.props.message?.agent_name}` : ''}>
                        <span>
                            {! this.props.replyFrom && ((this.props.user === 0 && this.props.platform !== 'EMAIL') || this.props.platform === 'WHATSAPP') &&
                                <IconButton
                                    className="message-actions"
                                    aria-controls="dropdown-menu"
                                    aria-haspopup="true"
                                    sx={{ position: 'absolute', top: '-3px', right: '0px', cursor: 'pointer' }}
                                    onClick={this.handleMessageMenuClick}
                                    aria-expanded={Boolean(this.state.messageMenuAnchorEl)}
                                >
                                    <ExpandMoreIcon sx={{
                                        color: 'white',
                                        fontSize: '1.2rem',
                                        transform: 'rotate(180deg) rotateX(180deg)'
                                    }}/>
                                </IconButton>
                            }
                            <Menu
                                id="dropdown-menu"
                                anchorEl={this.state.messageMenuAnchorEl}
                                open={Boolean(this.state.messageMenuAnchorEl)}
                                onClose={this.handleMessageMenuClose}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                MenuListProps={{
                                    'aria-labelledby': 'dropdown-button',
                                }}
                            >
                                {this.props.user === 0 && this.props.platform !== 'EMAIL' &&
                                    <MenuItem onClick={() => {
                                        this.sendMessageToAssistant(this.props.message.message)
                                        this.handleMessageMenuClose()
                                    }}>Perguntar ao assistente</MenuItem>
                                }
                                {this.props.user === 0 && this.props.platform !== 'EMAIL' &&
                                    <MenuItem onClick={() => {
                                        this.sendConsecutiveClientMessagesToAssistant()
                                        this.handleMessageMenuClose()
                                    }}>Perguntar este bloco ao assistente</MenuItem>
                                }
                                {this.props.platform === 'WHATSAPP' &&
                                    <MenuItem onClick={() => {
                                        this.replyMessage(this.props.message)
                                        this.handleMessageMenuClose()
                                    }}>Responder</MenuItem>
                                }
                            </Menu>
                            {replyFrom &&
                                <MessageItem key={`reply-from-${replyFrom.id}`}
                                    message={replyFrom}
                                    user={replyFrom.user_id}
                                    replyFrom={true}
                                    activeChat={this.props.activeChat}
                                />
                            }
                            {this.displayMessage(this.props.shouldBlurMessage)}
                            {! this.props.replyFrom &&
                                <Grid container justifyContent="center" sx={{ minWidth: "7.5rem" }}>
                                    <Grid item xs={(this.props.user == -1 || this.props.user == -99) ? 6 : 0}>
                                        {this.props.user == -1 &&
                                            <Box className="message-item-info">
                                                <Reddit />
                                                <Typography text=" ChatBot"
                                                    color="white"
                                                    variant="caption"
                                                    align="left"
                                                    justifyContent="left"
                                                />
                                            </Box>
                                        }
                                        {this.props.user == -9 && // Calls URLs
                                            (this.state.audioError ? (
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    gap: '8px',
                                                    padding: '8px 12px',
                                                    backgroundColor: 'rgba(0,0,0,0.1)',
                                                    borderRadius: '8px',
                                                    margin: '4px 0'
                                                }}>
                                                    <PhoneIcon sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '20px' }} />
                                                    <Typography 
                                                        text="Ligação de voz" 
                                                        color="white" 
                                                        variant="body2" 
                                                        align="left" 
                                                        justifyContent="left" 
                                                    />
                                                </Box>
                                            ) : (
                                                <ReactAudioPlayer
                                                    style={{ width: "250px", margin: "5px 0", height: "40px" }}
                                                    onError={() => this.setState({ audioError: true })}
                                                    src={this.props.message.message}
                                                    controls
                                                    preload
                                                />
                                            ))
                                        }
                                        {this.props.user == -99 &&
                                            <Box className="message-item-info">
                                                <NoteAltIcon />
                                                <Typography text=" Nota" color="white" variant="caption" align="left" justifyContent="left" />
                                            </Box>
                                        }
                                    </Grid>
                                    <Grid item xs={(this.props.user == -1 || this.props.user == -99) ? 6 : 12}>
                                        <Box className="bgTime">
                                            <Tooltip placement='bottom' title={calcDate(this.props.message.time, 'DD/MM/YYYY HH:mm')}>
                                                <span>
                                                    <Typography text={`${this.props.message.iso_time}`}
                                                        color="white"
                                                        variant="caption"
                                                        align="left"
                                                        justifyContent="left"
                                                    />
                                                </span>
                                            </Tooltip>
                                            {['WHATSAPP', 'WHATSAPP_ATIVO'].includes(this.props.platform) && this.props.message.user_id !== 0 && this.props.message.iso_time !== '--:--' &&
                                                <DoneAllIcon className={this.props.message.is_client_read ? "done-all-icon message-read" : "done-all-icon"}/>
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            }
                        </span>
                    </Tooltip>
                    {this.props.message.reaction &&
                        <Box className="message-reaction-emoji">{emojiReplaceJSX(this.props.message.reaction)}</Box>
                    }
                </Box>
                <DraggableBox 
                    show={this.state.showHtmlModal} 
                    handleClose={() => this.setState({ showHtmlModal: false, htmlContent: '' })} 
                    x={-window.innerWidth / 2 + 250}
                    y={-window.innerHeight / 2 + 250} 
                    className='draggable-box-email'
                    title='Visualização do E-mail'
                >
                    {ReactHtmlParser(this.state.htmlContent)}
                </DraggableBox>
            </Box>
        );
    }
}

export default MessageItem;

